const AdBanner = ({ adImg, link }) => {

    return (
        <div className=" container py-4">
            <div className=" p-2 shadow-lg rounded-md bg-white">
                <a href={link} className=" block rounded-md overflow-hidden h-[100px] md:h-[200px]">
                    <img src={adImg} className=' w-full h-full object-cover' alt="" />
                </a>
            </div>
        </div>
    )
}

export default AdBanner